import { render, staticRenderFns } from "./MarketCreate.vue?vue&type=template&id=15d3a5f5&scoped=true&"
import script from "./MarketCreate.vue?vue&type=script&lang=js&"
export * from "./MarketCreate.vue?vue&type=script&lang=js&"
import style0 from "./MarketCreate.vue?vue&type=style&index=0&id=15d3a5f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d3a5f5",
  null
  
)

export default component.exports